export enum JobApplicationSource {
  POSIZIONE = 'POSIZIONE',
  QUIZ = 'QUIZ',
  DIVENTA_AGENTE = 'DIVENTA AGENTE',
  LAVORA_CON_NOI = 'LAVORA CON NOI',
  FRANCHISING = 'FRANCHISING',
  LANDING = 'LANDING',
}
